module.exports = __webpack_public_path__ + "img/attack_pick.c7a6bc6c.png";